import { AlertSeverityEnum } from '@/shared/interfaces/erp/global/errors.interface';
import { ErrorMessagesForm } from '@/shared/interfaces/erp/global/global.interface';
import { HTTPResStatusCodeEnum } from '@/shared/interfaces/erp/global/axios.enum';
import { useUiStore } from '@/store/ui/ui.store';
import { AxiosError, isAxiosError } from 'axios';

export type ApiError = {
  status: number;
  code: string;
  message: string;
  type: string // frontend-error | backend-error
  data?: unknown;
};
export interface ErrorResponse {
  code: number;
  status: string;
  message: string;
  data: ErrorData;
}

export interface ErrorData {
  //errors: Record<string, string[]>;
  errors: {
    [key: string]: string[];
  };
}

export const handleAxiosError = (
  error: any,
  customMessageErrorToast?: string | null,
  customMessageErrorSeverityAlert = AlertSeverityEnum.error
) => {

  const setAlert = useUiStore.getState().setAlert;
  //const setAlert = useUiStore(s => s.setAlert);

  ///* axios errror handler
  if (isAxiosError(error)) {
    // custom message error
    if (customMessageErrorToast) {
      return setAlert(
        true,
        customMessageErrorToast,
        customMessageErrorSeverityAlert,
        5000
      );
    }

    console.log('error', error);


    // handle ErrorData from response
    const respAxiosData = error.response?.data || {};
    const { data } = (respAxiosData as ErrorResponse) || {};
    const { errors } = (data as ErrorData) || {};

    console.log('error data', data);

    // handle error as normal message
    if (!errors) {
      if (error?.response?.data?.message)
        return setAlert(
          true,
          customMessageErrorToast || error.response?.data?.message,
          customMessageErrorSeverityAlert
        );

      return setAlert(
        true,
        error?.message ||
        'Error no controlado, contacte al administrador del sistema',
        customMessageErrorSeverityAlert
      );
    }

    const errorMessages = Object.values(errors).flat();
    const alertMessage = errorMessages.join('\n');
    setAlert(true, alertMessage, customMessageErrorSeverityAlert);
    return;
  }

  if (error?.message) {
    return setAlert(true, error.message, customMessageErrorSeverityAlert);
  }

  setAlert(
    true,
    'Lo sentimos ocurrio un error desconocido, comunicarse con soporte técnico.',
    customMessageErrorSeverityAlert
  );
};

export const handleErrorForm = (errores: ErrorMessagesForm | any) => {
  const setAlert = useUiStore.getState().setAlert;

  for (const key in errores) {
    if (errores.hasOwnProperty(key)) {
      const aux = key.replace(/_/g, " ");

      //setAlert(true, `${aux.charAt(0).toUpperCase() + aux.slice(1)}: ${errores[key].message}`, AlertSeverityEnum.error);
      setAlert(true, `Campos obligatorios: ${aux.charAt(0).toUpperCase() + aux.slice(1)}`, AlertSeverityEnum.error);
    }
  }
};


export function toApiError(err: unknown): ApiError {

  if (isAxiosError(err)) {
    const ax = err as AxiosError<any>;
    const status = ax.response?.status ?? 0;

    console.log('=========ax', ax);
    // Intenta leer un cuerpo estándar del backend { code, message, details }
    const data = ax.response?.data as any;

    const code = data?.code ?? ax.code;

    let message = 'Lo sentimos los servicios no estan disponible, volver a intentar mas tarde';
    let type = "frontend-error";

    if (status == 401) message = "Sesión expirada. [401]"
    if (status == 403) message = "Acceso denegado. No cumples con los permisos necesarios: [403]"
    if (status == 404) message = "La petición solicitada no pudo ser encontrada. [404]"

    if (data?.message) message = data?.message

    if (code == HTTPResStatusCodeEnum.ECONNABORTED
      || code == HTTPResStatusCodeEnum.ERR_NETWORK
      || code == HTTPResStatusCodeEnum.ERR_BAD_RESPONSE
      || status >= 500) {

      if (data?.message) {
        message = data?.message
      } else {
        message = `Lo sentimos los servicios no estan disponible, volver a intentar mas tarde. [${code}]`
      }

      type = "backend-error"
    }

    return {
      status,
      code,
      message,
      data: data?.data ?? null,
      type
    };
  }

  // fallback
  return {
    status: 0,
    code: 'UNKNOWN_ERROR',
    message: "Ha ocurrido un inconveniente inesperado. Por favor, comunícate con el área de soporte técnico para recibir asistencia. [DESARROLLO]",
    type: 'unknown-error'
  };
}

